// Method names in integrations must be same as Event Type.

export const TELEMETRY_EVENT_NAMES = {
  // Standard events
  PAGE_VIEW: 'pageView', // Skipping in new site. being done in old site.
  PRODUCT_VIEW: 'productView', // Done but vendor is missing from properties.
  ADD_TO_CART: 'addToCart', // Added in USE Card check if line items is correct
  BUY_NOW: 'buyNow',
  APPLE_PAY_CLICK: 'applePayClick',
  APPLE_PAY_PAYMENT_INITIATED: 'applePayPaymentInitiated',
  APPLE_PAY_PAYMENT_FAILED: 'applePayPaymentFailed',
  REMOVE_FROM_CART: 'removeFromCart', // Added in USE Card check if line items is correct
  UPDATE_ITEM_QUANTITY: 'updateItemQuantity', // Added in USE Card check if line items is correct
  SAVE_FOR_LATER: 'saveForLater',
  MOVE_TO_BAG: 'moveToBag',
  HOME_PAGE_VIEW: 'homePageView', // Added
  COLLECTION_VIEW: 'collectionView',
  SEARCH_PAGE_VIEW: 'searchPageView',
  CART_PAGE_VIEW: 'cartPageView',
  WISHLIST_PAGE_VIEW: 'wishlistView',
  EMAIL_NEWSLETTER_SUBSCRIBE: 'emailNewsletterSubscribe',
  SMS_NEWSLETTER_SUBSCRIBE: 'smsNewsletterSubscribe',
  DIRECT_BUY_CLICK: 'directBuyClick', // Didnt have any usage in old website code. So no changes made.
  SEND_REFERRAL_EMAIL_INVITE: 'sendReferralEmailInvite',
  ADD_TO_WISHLIST: 'addToWishList', // Added to useWishlist.
  REMOVE_FROM_WISHLIST: 'removeFromWishList', // Added to useWishlist.
  ORDER_CANCEL: 'orderCancel',
  PRODUCT_CLICK: 'product_click',
  WISHLIST_LOAD: 'wishlist_load',
  SHARED_WISHLIST_LOAD: 'shared_wishlist_load',
  SHARE_WISHLIST: 'share_wishlist',
  // User interaction events
  COOKIE_PREFERENCE_SAVED: 'cookie_preference_saved',
  COOKIE_SETTINGS_OPENED: 'cookie_settings_opened',
  COOKIE_BANNER_SHOWN: 'cookie_banner_shown',
  SESSION_CREATE: 'sessionCreate', // Used only in initilizeAnalytics.
  BUTTON_CLICK: 'buttonClick',
  LINK_CLICK: 'linkClick',
  FORM_SUBMIT: 'formSubmit',
  ACCORDION_TOGGLE: 'accordionToggle',
  FORM_OPEN: 'formOpen',
  FORM_CLOSE: 'formClose',
  MODAL_OPEN: 'modalOpen',
  MODAL_CLOSE: 'modalClose',
  PAGE_SCROLL: 'pageScroll',
  SEARCH: 'search', // Added in SearchBoxSection.tsx
  ENTER_FEEDBACK: 'enterFeedback',
  VIDEO_LOAD: 'videoLoad',
  VIDEO_PLAYED: 'videoPlayed',
  VIDEO_COMPLETED: 'videoCompleted',
  FILTER_CLICK: 'filterClick',
  VIEW_BAG_BUTTON_CLICKED: 'view_bag_button_clicked',
  CHECKOUT_BUTTON_CLICKED: 'checkout_button_clicked',
  CLICKED_TO_SEARCH: 'clickedToSearch',
  SEARCH_TRIGGERED: 'searchTriggered',
  TOP_NAV_OPENED: 'topNavOpened',
  PROFILE_MENU_OPENED: 'profileMenuOpened',
  HEADER_LOGO_CLIKED: 'headerLogoClicked',
  APP_PUSH_BANNER_INSTALL_CLICKED: 'appPushBannerInstallClicked',
  APP_PUSH_BANNER_VIEWED: 'appPushBannerViewed',
  APP_INSTALL_CLICKED: 'appInstallClicked',
  SORT_OPENED: 'sortOpened',
  SORT_USED: 'sortUsed',
  FAQ_VIEWED: 'faqViewed',
  FAQ_CLICKED: 'faqClicked',
  ADDRESS_ADDITION_INITIATED: 'addressAdditionInited',
  ADDRESS_ADDITION_SUCCESSFUL: 'addressAdditionSuccessful',
  ADDRESS_EDIT_SUCCESSFUL: 'addressEditSuccessful',
  PRODUCT_GALLERY_VIEWED: 'productGalleryViewed',
  PRODUCT_GALLERY_LOADED: 'productGalleryLoaded',
  REVIEWS_SORTED: 'reviewsSorted',
  REVIEW_PAGE_NAVIGATED: 'review_page_navigated',
  REVIEW_VIEWED: 'review_viewed',
  REVIEW_AUTO_SCROLL_TRIGGERED: 'auto_scroll_triggered',
  SEARCH_COMPLETED: 'searchCompleted',
  SIMILAR_COLLECTION_CLICKED: 'similarCollectionClicked',
  SUBCOLLECTION_FILTER_USED: 'subcollectionFilterUsed',
  VARIANT_SELECTED: 'variantSelected',
  USER_LOGGED_IN: 'userLoggedIn',
  USER_SIGNED_UP: 'userSignedUp',
  PRODUCT_GALLERY_SCROLLED: 'productGalleryScrolled',
  PRODUCT_CARD_SCROLLED: 'productCardScrolled',
  SUBSCRIPTIONS_RADIO_BUTTON_SELECTED: 'subscriptionsRadioButtonSelected',
  SUBSCRIPTIONS_SHIPPING_FREQUENCY_CHANGE: 'subscriptionsShippingFrequencyChange',

  // Product Page specific events
  ZOOM_PRODUCT_IMAGE: 'zoomProductImage',
  JOIN_THE_WAITLIST: 'joinTheWaitlist', // TODO: Old site had 2 place. Verify if needed to add other place also.
  JOIN_THE_WAITLIST_SMS: 'joinTheWaitlistSms',

  // Site errors
  SITE_ERROR: 'site_error', // TODO: This was not added anywhere to to add.

  // Api Response
  API_RESPONSE: 'apiResponse',

  //  element visisble events
  IS_VISIBLE: 'isVisible',

  IS_VIDEO_WATCHED: 'isVideoWatched',
  VISUAL_CUE_CLICK: 'visual_cue_click',

  IDME_VERIFICATION: 'idmeVerification',
  PREORDER_INFO_CLICK: 'PREORDER_INFO_CLICK',

  //RECOMMENDATION
  RECOMMENDATION_VIEW: 'recommendationView',
  RECOMMENDATION_PRODUCT_VIEW: 'recommendedProductView',
  CAROUSEL_RIGHT_CLICK: 'rightSwipe',
  CAROUSEL_LEFT_CLICK: 'leftSwipe',

  MAIL_TO_US_CLICKED: 'MAIL_TO_US_CLICKED',
  PHONE_TO_US_CLICKED: 'PHONE_TO_US_CLICKED',
  CHAT_WITH_US_CLICKED: 'CHAT_WITH_US_CLICKED',
  CART_VIEW: 'CART_VIEW',
  EXPRESS_CHECKOUT_CART_LOADED: 'EXPRESS_CHECKOUT_CART_LOADED',
  EXPRESS_CHECKOUT_CART_LOAD_FAILED: 'EXPRESS_CHECKOUT_CART_LOAD_FAILED',
  SUBCOLLECTION_CARD_CLICK: 'SUBCOLLECTION_CARD_CLICK',
  VARIANT_SELECT: 'VARIANT_SELECT',

  // BULK ANALYTICS EVENTS
  BULK_PRODUCT_CARD_VIEW: 'BULK_PRODUCT_CARD_VIEW',

  // ATC CONFIRMATION (atc_confirmationandrecommendation_mweb)
  ATC_CONFIRMATION_BOTTOM_SHEET_VIEW: 'atc_confirmation_bottom_sheet_view',
  ATC_CONFIRMATION_BOTTOM_SHEET_DISMISS: 'atc_confirmation_bottom_sheet_dismiss',

  // TRUEFIT WIDGET EVENTS
  TF_WIDGET_OPEN: 'TF_WIDGET_OPEN',
  TF_SIZE_RECOMMENDATION: 'TF_SIZE_RECOMMENDATION',
  TF_WIDGET_LOAD: 'TF_WIDGET_LOAD',
  TF_EXPERIMENTS: 'TF_EXPERIMENTS',

  // Internal analytics
  INTERNAL_ANALYTICS: 'INTERNAL_ANALYTICS',
  MIXPANEL: 'MIXPANEL',
  DO_NOT_TRACK: 'DO_NOT_TRACK',

  // AUTHENTICATION
  CUSTOMER_ID_SYNC_ERROR: 'CUSTOMER_ID_SYNC_ERROR',

  // B2B AUTHENTICATION FUNNEL
  B2B_PAGE_VIEW: 'corporate_page_view',
  B2B_LOGIN_EMAIL_SUBMITTED: 'login_email_submitted',
  B2B_LOGIN_OTP_SUBMITTED: 'login_otp_submitted',
  B2B_LOGIN_SUCCESS: 'login_success',
  B2B_LOGIN_FAILED: 'login_failed',

  // STREAMING VIDEO
  STREAMING_VIDEO_LOAD: 'STREAMING_VIDEO_LOAD',
  STREAMING_VIDEO_ERROR: 'STREAMING_VIDEO_ERROR',

  //RETURNS REVAMP
  RETURN_LINE_ITEMS_SCREEN_VIEW: 'RETURN_LINE_ITEMS_SCREEN_VIEW',
  RETURN_FEE_TOOLTIP_HOVER: 'RETURN_FEE_TOOLTIP_HOVER',
  SUBMIT_LINE_ITEMS_CTA_CLICK: 'SUBMIT_LINE_ITEMS_CTA_CLICK',
  REFUND_AMOUNT_SCREEN_VIEW: 'REFUND_AMOUNT_SCREEN_VIEW',
  REFUND_AMOUNT_API_COMPLETED: 'REFUND_AMOUNT_API_COMPLETED',
  SUBMIT_RETURN_API_COMPLETED: 'SUBMIT_RETURN_API_COMPLETED',
  RETURN_FLOW_API_ERROR: 'RETURN_FLOW_API_ERROR',
  RETURN_CONFIRM_CTA_CLICK: 'RETURN_CONFIRM_CTA_CLICK',
  RETURN_CONFIRM_SCREEN_VIEW: 'RETURN_CONFIRM_SCREEN_VIEW',
  RETURN_ITEM_SELECTED: 'RETURN_ITEM_SELECTED',
  EXCHANGE_FOR_NEW_SELECTED: 'EXCHANGE_FOR_NEW_SELECTED',
  PROGRESSIVE_RETURN_FLOW_VISIBLE: 'PROGRESSIVE_RETURN_FLOW_VISIBLE',
  RETURNLESS_REFUND_MESSAGE_VISIBLE: 'RETURNLESS_REFUND_MESSAGE_VISIBLE',
  PROGRESSIVE_RETURN_FLOW_CONTINUE_CTA: 'PROGRESSIVE_RETURN_FLOW_CONTINUE_CTA',

  // orders list page
  ORDERS_LIST_FETCHED: 'ORDERS_LIST_FETCHED',
  ORDERS_LIST_ERROR: 'ORDERS_LIST_ERROR',
  PAST_ORDERS_FETCHED: 'PAST_ORDERS_FETCHED',
  PAST_ORDERS_ERROR: 'PAST_ORDERS_ERROR',

  // subscriptions list page
  SUBSCRIPTIONS_LIST_VIEWED: 'SUBSCRIPTIONS_LIST_VIEWED',
  SUBSCRIPTIONS_LIST_ERROR: 'SUBSCRIPTIONS_LIST_ERROR',
  SUBSCRIPTIONS_PAGE_ACTION: 'SUBSCRIPTIONS_PAGE_ACTION',
  SUBSCRIPTIONS_MANAGEMENT_ACTIONS: 'SUBSCRIPTIONS_MANAGEMENT_ACTIONS',

  // subscriptions details page
  CHANGE_NEXT_ORDER_DATE: 'CHANGE_NEXT_ORDER_DATE',
  CHANGE_SHIPPING_FREQUENCY: 'CHANGE_SHIPPING_FREQUENCY',
  CHANGE_SHIPPING_QUANTITY: 'CHANGE_SHIPPING_QUANTITY',
  CHANGE_SHIPPING_ADDRESS: 'CHANGE_SHIPPING_ADDRESS',
  CHANGE_SHIPPING_ADDRESS_ERROR: 'CHANGE_SHIPPING_ADDRESS_ERROR',
  CANCEL_SUBSCRIPTION_BUTTON_CLICK: 'CANCEL_SUBSCRIPTION_BUTTON_CLICK',
  CHARGE_BACK_OPTIONS_SURFACED: 'CHARGE_BACK_OPTIONS_SURFACED',
  CONTINUE_TO_CANCEL: 'CONTINUE_TO_CANCEL',
  CANCEL_SUBSCRIPTION_CONFIRMATION_CLICK: 'CANCEL_SUBSCRIPTION_CONFIRMATION_CLICK',
  CURRENT_ORDER_VIEW_DETAILS_CLICK: 'CURRENT_ORDER_VIEW_DETAILS_CLICK',
  CHANGE_NEXT_ORDER_DATE_RESULT: 'CHANGE_NEXT_ORDER_DATE_RESULT',
  CHANGE_SHIPPING_FREQUENCY_RESULT: 'CHANGE_SHIPPING_FREQUENCY_RESULT',
  CHANGE_SHIPPING_QUANTITY_RESULT: 'CHANGE_SHIPPING_QUANTITY_RESULT',
  SUBSCRIPTION_CANCELLED: 'SUBSCRIPTION_CANCELLED',
  PAST_ORDERS_DRAWER_OPENED: 'PAST_ORDERS_DRAWER_OPENED',
  ADDRESS_SELECTOR_OPENED: 'ADDRESS_SELECTOR_OPENED',
  ADDRESS_FORM_OPENED: 'ADDRESS_FORM_OPENED',
  CUSTOMER_ADDRESSES_FETCH_ERROR: 'CUSTOMER_ADDRESSES_FETCH_ERROR',

  // subscription vault payment events
  PAYMENT_CHANGE_INITIATED: 'PAYMENT_CHANGE_INITIATED',
  PAYMENT_CHANGE_STATUS: 'PAYMENT_CHANGE_STATUS',
  CHANGE_PAYMENT_METHOD: 'CHANGE_PAYMENT_METHOD',
  RETRY_CARD_INITIATED: 'RETRY_CARD_INITIATED',
  RETRY_CARD_STATUS: 'RETRY_CARD_STATUS',

  // orders detail page
  ORDER_DETAILS_FETCHED: 'ORDER_DETAILS_FETCHED',
  ORDER_DETAILS_ERROR: 'ORDER_DETAILS_ERROR',
  ORDER_DETAILS_ACTIONS: 'ORDER_DETAILS_ACTIONS',

  //CONTACT US
  SUPPORT_SECTION_CLICKED: 'support_section_clicked',
  SUPPORT_CHAT_INITIATED: 'support_chat_initiated',

  //EFA & PDP events
  RETURNS_REFUND_TYPE_SELECTED: 'RETURNS_REFUND_TYPE_SELECTED',
  RETURNS_REFUND_TYPE_SUBMITTED: 'RETURNS_REFUND_TYPE_SUBMITTED',
  PRODUCT_SUMMARY_IS_VISIBLE: 'PRODUCT_SUMMARY_IS_VISIBLE',

  // Size chart
  SIZE_CHART_CLICKED: 'size_chart_clicked',
  SIZE_CHART_TAB: 'size_chart_tab',
  SIZE_CHART_TOGGLE: 'size_chart_toggle',

  // Klarna Events
  KLARNA_PAYMENTS_MESSAGE_VIEWED: 'KLARNA_PAYMENTS_MESSAGE_VIEWED',
  KLARNA_PAYMENTS_LINK_CLICKED: 'KLARNA_PAYMENTS_LINK_CLICKED',

  //RANDOM temp constant
  //Todo(sachin):Remove this after Platfrom AB
  NEW_USER_CREATED_RANDOM: 'NEW_USER_CREATED_RANDOM',

  // New CLP Filters
  FILTER_OPENED: 'FILTER_OPENED',
  FILTER_APPLIED: 'FILTER_APPLIED',
  FILTERS_CLEARED: 'FILTERS_CLEARED',
  INDIVIDUAL_FILTERS_CLEARED: 'INDIVIDUAL_FILTERS_CLEARED',
  EMPTY_FILTERED_RESULTS: 'EMPTY_FILTERED_RESULTS',

  // MiniPDP Events
  PRODUCT_FULL_DETAILS_VIEWED: 'PRODUCT_FULL_DETAILS_VIEWED',
  ATC_LINK_CLICKED: 'ATC_LINK_CLICKED',

  //Stylitics
  STYLITICS_ITEM_VIEW: 'stylitics_item_view',
  STYLITICS_ITEM_CLICK: 'stylitics_item_click',
  STYLITICS_CTL_CLICK: 'ctl_click',

  //Wine Events
  DOB_MODAL_OPENED: 'DOB_MODAL_OPENED',
  DOB_ADDED: 'DOB_ADDED',
  DOB_ADDED_ERROR: 'DOB_ADDED_ERROR',
  DOB_REMOVED: 'DOB_REMOVED',

  //Hubspot Form
  HUBSPOT_FORMS_SCRIPT_LOAD_FAILED: 'HUBSPOT_FORMS_SCRIPT_LOAD_FAILED',
  HUBSPOT_FORM_SUBMIT_SUCCESS: 'HUBSPOT_FORM_SUBMIT_SUCCESS',
  HUBSPOT_LEGACY_FORM_SUBMIT_INITIATED: 'HUBSPOT_LEGACY_FORM_SUBMIT_INITIATED',
  HUBSPOT_FORM_SUBMIT_FAILED: 'HUBSPOT_FORM_SUBMIT_FAILED',

  // App Exclusive
  APP_EXCLUSIVE_MODAL_OPENED: 'app_exclusive_modal_opened',
  APP_EXCLUSIVE_LINK_CLICKED: 'app_exclusive_link_clicked',
  QR_RENDERED_SUCCESS: 'qr_rendered_success',
  QR_RENDERED_ERROR: 'qr_rendered_error',

  // Subscriptions - Cart
  CART_PAGE_ACTION: 'cart_page_action',
  CART_ITEMS_FETCHED: 'cart_items_fetched',
  // Diagnostic: cart-service 422 "Region ID mismatch" (incoming region != cart's stored region)
  CART_REGION_ID_MISMATCH: 'cart_region_id_mismatch',
  // Find My Order
  ORDER_SEARCH_STARTED: 'ORDER_SEARCH_STARTED',
  ORDER_SEARCH_RESULTS: 'ORDER_SEARCH_RESULTS',
  FIND_MY_ORDER_WIDGET_CLICKED: 'FIND_MY_ORDER_WIDGET_CLICKED',
  INITIATE_OTP_CHECK: 'INITIATE_OTP_CHECK',
  OTP_RESEND_ATTEMPT: 'OTP_RESEND_ATTEMPT',
  OTP_VALIDATE_ATTEMPT: 'OTP_VALIDATE_ATTEMPT',
  SIGN_IN_STARTED: 'SIGN_IN_STARTED',
  FMO_SWITCH_ACCOUNT_CTA_CLICKED: 'FMO_SWITCH_ACCOUNT_CTA_CLICKED',
  OTP_SIGN_IN_MODAL_OPEN: 'OTP_SIGN_IN_MODAL_OPEN',
  OTP_SIGN_IN_SUCCESS: 'OTP_SIGN_IN_SUCCESS',
  OTP_SIGN_IN_FAILURE: 'OTP_SIGN_IN_FAILURE',
  OTP_SIGN_IN_RESEND: 'OTP_SIGN_IN_RESEND',

  // Header / locale
  HEADER_GLOBAL_ICON_SELECTED: 'header_global_icon_selected',
  LOCALE_SWITCH_MODAL_OPEN: 'locale_switch_modal_open',
  LOCALE_SWITCH_MODAL_SAVED: 'locale_switch_modal_saved',
  LOCALE_SWITCH_HEADSUP_POPUP_SELECTED: 'locale_switch_headsup_popup_selected',
  DIRECT_LOCALE_RADIO: 'direct_locale_radio_button_selected',
  LOGOUT: 'logout',

  // B2B Customization
  CUSTOMIZATION_CHECKBOX_CLICK: 'customization_checkbox_click',
  CUSTOMIZATION_PAGE_VIEW: 'customization_page_view',
  CUSTOMIZATION_PAGE_LOGO_UPLOAD: 'customization_page_logo_upload',
  CUSTOMIZATION_PAGE_NEXT_BUTTON: 'customization_page_next_button',

  // B2B Cart
  B2B_DELETE_CUSTOMIZATION_FROM_CART: 'delete_customization',
  B2B_DELETE_CART_GROUP: 'delete_cart_group',

  //B2B Error Page
  B2B_ERROR_PAGE: 'b2b_error_page',

  LEAD: 'LEAD',
  FALLBACK_REGION_ID: 'FALLBACK_REGION_ID',

  // Earn Credit
  EARN_CREDIT_VIEWED: 'earnCreditViewed',
  BEST_MARKET_VALUE_VIEWED: 'bestMarketValueViewed',

  // fingerprinting
  FINGERPRINT_RECEIVED: 'qfp_visitor_id_received',
  FINGERPRINT_REQUESTED: 'qfp_visitor_id_requested',

  // Review Image Upload
  ADD_PHOTO_CLICKED: 'add_photo_clicked',
  REVIEW_IMAGE_UPLOADED: 'review_image_uploaded',

  // Review submission flow
  RATING_ADDED: 'rating_added',
  REVIEW_DETAILS_ADDED: 'review_details_added',
  REVIEW_DETAILS_SUBMITTED: 'review_details_submitted',
  REVIEW_SUBMISSION_ERROR_LOG: 'review_submission_error_log',

  // Unified checkout analytics (dual-emit)
  UNIFIED_PAY_BUTTON_CLICK: 'unifiedPayButtonClick',
  UNIFIED_PAYMENT_INITIATED: 'unifiedPaymentInitiated',
  UNIFIED_PAYMENT_AUTHORISED: 'unifiedPaymentAuthorised',
  CHECKOUT_ERROR_LOG_WEB_CHECKOUT: 'checkoutErrorLogWebCheckout',

  //performance events
  FCP_EVENT: 'fcp_event',
  LCP_EVENT: 'lcp_event',
  CLS_EVENT: 'cls_event',
  TTFB_EVENT: 'ttfb_event',
  INP_EVENT: 'inp_event',

  // Live Event LP
  LIVE_EVENT_CTA_CLICKED: 'live_event_cta_clicked',
} as const

export const TELEMETRY_EVENT_ACIONS = {
  FOOTER_COOKIE_PREFERENCE: 'footer_cookie_preference',
  CAROUSEL_LEFT_CLICK: 'click__carousel__left',
  CAROUSEL_RIGHT_CLICK: 'click__carousel__right',
} as const

export const TELEMETRY_EVENT_CATEGORIES = {
  NAVIGATION: 'navigation',
  REVIEWS: 'reviews',
} as const

export const TELEMETRY_EVENT_ENTITY_TYPES = {
  REVIEWS: 'reviews',
} as const

export const TELEMETRY_EVENT_ENTITY_IDS = {
  WRITE_REVIEW_SECTION_VIEWED: 'write_review_section_viewed',
} as const
